module.exports = __webpack_public_path__ + "img/bg4.c2a565c7.jpg";